<template>
  <div class="message-thread__prompt" :style="{ paddingTop: paddingTop }">
    <v-icon :icon="icon" size="3rem" />
    <div class="heading mt-2">{{ heading }}</div>
    <p class="description mt-1">{{ description }}</p>
    <div v-if="to" class="message-thread__button">
      <v-button block :to="to">{{ buttonText }}</v-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: { type: String, default: "forum" },
    heading: { type: String, default: "" },
    description: { type: String, default: "" },
    to: { type: String, default: null },
    buttonText: { type: String, default: null },
    paddingTop: { type: String, default: "30vh" }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.message-thread__prompt {
  display: flex;
  height: 100%;
  padding: 0 2rem;
  flex-direction: column;
  align-items: center;

  .material-icons-round {
    color: $color-ui--grey-50;
  }

  .heading {
    font-size: 16px;
    color: $color-ui--dark-blue;
    font-weight: bold;
  }

  .description {
    margin-bottom: 2rem;
    font-size: 15px;
    color: $color-ui--grey-70;
    font-weight: 500;
    line-height: 22px;
    text-align: center;
    white-space: pre-line;
  }

  .message-thread__button {
    width: 60%;
  }
}
</style>
